import Cookie from 'js-cookie';
import fetch from 'cross-fetch';
import type { ReferrerType, DiscountType, CouponType } from '../types';
import { attributesToQueryString } from '@farmersdog/utils';

const ANONYMOUS_ID_COOKIE_NAME = 'ajs_anonymous_id';
function getAnonymousId() {
  return Cookie.get(ANONYMOUS_ID_COOKIE_NAME);
}

export interface ReferrerIdRequest {
  id: number;
  type: ReferrerType;
}

export interface ReferrerCodeRequest {
  code: string;
  type: ReferrerType;
}

export type CouponRequest = ReferrerIdRequest | ReferrerCodeRequest;

export interface CouponResponse {
  id: number;
  bannerCopy: string | null;
  type: CouponType;
  discountType: DiscountType;
  discountPercentage?: number;
  discountAmount: number;
  invalid: boolean;
}
export interface UserReferrerResponse {
  id: number;
  name: string;
  discountType: DiscountType;
  discountPercentage?: number;
  discountAmount: number;
  invalid: boolean;
  // Pre-rendered server-side for user referrers. Populated by core-api so the
  // FE can drop its own interpolation once shadow logging confirms parity.
  bannerCopy?: string | null;
}

export const REFERRAL_NOT_FOUND_RESPONSE_DATA = 'Not Found';

export type ReferrerResponse =
  | CouponResponse
  | UserReferrerResponse
  | typeof REFERRAL_NOT_FOUND_RESPONSE_DATA;

export interface ApiResponse<T> {
  data: T;
}

export interface GetCouponArgs {
  apiUrl: string;
  coupon: CouponRequest;
}

export async function getCoupon({
  apiUrl,
  coupon,
}: GetCouponArgs): Promise<ReferrerResponse> {
  const anonymousId = getAnonymousId();
  const url = `${apiUrl}${attributesToQueryString(
    { ...coupon, anonymousId },
    {
      addQueryPrefix: true,
    }
  )}`;

  const response = await fetch(url);

  const json = (await response.json()) as ApiResponse<ReferrerResponse>;

  return json.data;
}
